import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";
export default function CandidateInformation({ open, setOpen, modalData }) {
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === true) {
    } else {
      console.log("close");
    }
  }, [open]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const labelStyle = {
    fontWeight: 500,
    color: "#01008B",
    fontSize: { xs: "12px", sm: "13px", md: "14px", lg: "15px" },
    whiteSpace: "nowrap",
  };
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    fontWeight: 500,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "14px", lg: "15px" },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "90%", sm: "50%", md: "40%", lg: "25%" },
          overflowY: "auto",
          height: { xs: "35vh", sm: "35vh", md: "40vh", lg: "35vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "25%", md: "35%", lg: "40%" },
          top: "32%",
        }}
      >
        <ModalHeader title="Candidate Information" onClose={setOpen} />

        {/* <Divider sx={{ borderBottom: "1px solid #01008B" }} /> */}
        <DialogContent sx={{ p: 2, mt: 2 }}>
          <Grid container>
            {/* intro */}
            <Grid container spacing={2}>
              {/* LEFT SIDE */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "180px 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}> Date of Enquiry :</Typography>
                  <Typography sx={valueStyle}>
                    {formatDate(modalData?.appliedDate) || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Candidate Name :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.userName || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Mobile No. :</Typography>
                  <Typography sx={{...valueStyle, display:'flex'}} >
                    {modalData?.userMobile || "-"}
                    {modalData?.userMobile && (
                      <IconButton
                        size="small"
                        sx={{ p: 0, ml: 1 }}
                        onClick={() =>
                          window.open(
                            `https://web.whatsapp.com/send?phone=${modalData?.userMobile}`,
                            "_blank",
                          )
                        }
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "white",
                            fontSize: 20,
                            borderRadius: "50%",
                            backgroundColor: "#25D366",
                            p: "3px",
                          }}
                        />
                      </IconButton>
                    )}
                  </Typography>

                  <Typography sx={labelStyle}>Email Id :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.userEmail || "-"}
                  </Typography>
                  <Typography sx={labelStyle}>Address :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.area || "-"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Box>
    </Modal>
  );
}
